import { useEffect } from 'react'
import { getStyles, getAiVideoModelsApi } from '../context/api-helpers'
import {
  IAiImageStyleItem,
  IStyleOption,
  TVideosAction
} from '../context/interfaces'
import { logError } from 'utils/logger'

export const useInitialFetch = (dispatch: React.Dispatch<TVideosAction>) => {
  useEffect(() => {
    const fetchInitialData = async () => {
      dispatch({ type: 'SET_INITIALIZING', payload: true })

      try {
        const [stylesResponse, modelsResponse] = await Promise.all([
          getStyles(),
          getAiVideoModelsApi()
        ])

        // Process styles
        const styles: IStyleOption[] = stylesResponse.data.map(
          (style: IAiImageStyleItem) => ({
            id: style.id,
            label: style.name
          })
        )

        const stylesWithAiChoice: IStyleOption[] = [
          { id: 0, label: 'Ai Choice' },
          ...styles
        ]

        dispatch({ type: 'SET_STYLES', payload: stylesWithAiChoice })
        dispatch({ type: 'SET_MODELS', payload: modelsResponse.data })
      } catch (error) {
        logError(error)
      } finally {
        dispatch({ type: 'SET_INITIALIZING', payload: false })
      }
    }

    fetchInitialData()
  }, [dispatch])
}
